import { ReactElement } from "react";
import { useParams } from "react-router-dom";

export const DatasetItem = (): ReactElement => {
  const { id } = useParams<{ id: string }>();
  return <p>This is the datesets page {id}</p>;
};

export default DatasetItem;
